import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    boosting: false,
 };

export const boostingSlice = createSlice({
    name: 'boosting',
    initialState,
    reducers: {
        setBoosting(state, action) {
            state.boosting = action.payload;
        },
    }
});

export default boostingSlice;